import { useAuthSelector } from 'app/data/auth';
import callDetailRecordQueryKeys from 'app/hooks/queries/callDetailRecord/callDetailRecordQueryKeys';
import { sdk } from 'app/sdk';
import { useQuery } from 'react-query';
import { CdrInteractionsPageResponse } from 'types/callDetailRecord';

export const useListCdrInteractionsQuery = (
  skip: number,
  take: number,
  orderBy: any,
  filters: any,
) => {
  // returns list of callDetailRecords
  // - just get ALL callDetailRecords+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = callDetailRecordQueryKeys.interactionsList(
    skip,
    take,
    orderBy,
    filters,
  );

  const query = useQuery<CdrInteractionsPageResponse, Error>(
    queryKey,
    () =>
      sdk.callDetailRecord.query.cdrInteractions(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListCdrInteractionsQuery;
